const TENANT_ID = process.env.NEXT_PUBLIC_TENANT;

// @ts-ignore
const { default: tenantConfig } = await import(`./${TENANT_ID}.js`);

export default tenantConfig;
